module.exports = __webpack_public_path__ + "static/media/service_caseStudy.955f5159.jpg";